export default ".gh-email-receiving-faq {\n\n}\n";